import { isBrowser } from '@/lib/utils';

const isIos = () => {
  if (!isBrowser()) return false;
  const userAgent = window.navigator.userAgent.toLowerCase();
  return /iphone|ipad|ipod/.test(userAgent);
};

export default isIos;
